import template from "./pCasemanTeamsConfig.html";

export function pCasemanTeamsConfigDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pCasemanTeamsConfigController,
    controllerAs: 'pCasemanTeamsConfig',
    bindToController: true
  };

  return directive;
}

class pCasemanTeamsConfigController {
  constructor($scope, $location, $interval, $routeParams, $q, $translate, Auth, Caseman, Notes, Sort, Utils, ConnectionQuality) {
    'ngInject';
    this.$scope = $scope;
    this.$location = $location;
    this.$interval = $interval;
    this.$routeParams = $routeParams;
    this.$q = $q;
    this.Auth = Auth;
    this.Caseman = Caseman;
    this.Notes = Notes;
    this.Sort = Sort;
    this.Utils = Utils;
    this.ConnectionQuality = ConnectionQuality;
    this.siteIdKlix = this.$routeParams.siteId;
    this.siteNameKlix = this.$routeParams.siteName;
    this.state = "loading";
    this.matchBlocked = false;

    this.siteCASEman = {id: 0, name: $translate.instant("CASEMAN.ALL"), shortcut: $translate.instant("CASEMAN.ALL")};

    this.headers = [
      {name: "CASEMAN.TEAM_KLIX", class: null},
      {name: "CASEMAN.TEAM_CASEMAN", class: "table-caseman"}
    ];

    this.Auth.authorize().then(
      (user) => {
        this.user = user;

        //Notes...
        const timeout = this.$interval(() => {this.notes = this.Notes.getNotes();}, 200);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout );});

        let promises = [
          this.Caseman.getTeamsKlixBySite(this.siteIdKlix),
          this.Caseman.getTeamsMapperBySite(this.siteIdKlix)
        ];

        this.$q.all(promises).then(
          (success) => {
            this.teamsKlix = success[0].data.sort(this.Sort.abcBy("name"));
            this.siteTeamsMapper = success[1].data;

            this.siteTeamsMapperDisplay = this.teamsKlix.map(tKlix => {
              let team = this.siteTeamsMapper.find( team => team.teamId == tKlix.id);
              if(!team) {
                team = {teamId: tKlix.id , teamName: tKlix.name, casemanTeamId: null, casemanTeamName: null, unmatched: true};
              }
              return team;
            });
            this.state = "loaded";
          },
          (error) => {
            this.state = "error";
            this.Notes.postNote({type: "error", error: error});
          }
        );
        this.Caseman.getSitesCASEMAN().then(
          (success) => {
            this.sitesCASEman = success.data.sort(this.Sort.abcBy("name"));
            this.sitesCASEman.unshift({id: 0, name: $translate.instant("CASEMAN.ALL"), shortcut: $translate.instant("CASEMAN.ALL")});

            this.state = "siteLoaded";
          },
          (error) => {
            this.state = "error";
            this.Notes.postNote({type: "error", error: error});
          }
        );
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  refresh() {
    this.Caseman.getTeamsMapperBySite(this.siteIdKlix).then(
      (success) => {
        this.siteTeamsMapper = success.data;
        this.siteTeamsMapperDisplay = this.teamsKlix.map(tKlix => {
          let team = this.siteTeamsMapper.find( team => team.teamId == tKlix.id);
          if(!team) {
            team = {teamId: tKlix.id , teamName: tKlix.name, casemanTeamId: null, casemanTeamName: null, unmatched: true};
          }
          return team;
        });
        this.matchBlocked = this.Utils.blockMatch(this.siteTeamsMapperDisplay);
        this.state = "loaded";
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  closeConfigSite() {
    this.$location.path('/caseman/teamConfig/');
  }

  backToSites() {
    window.history.back();
  }

  editTeam(entity) {
    this.matchBlocked = this.Utils.blockMatch(this.siteTeamsMapperDisplay);
    this.selectedTeam = {id: entity.casemanTeamId, name: entity.casemanTeamName};
    this.hintName = entity.teamName.substr(entity.teamName.indexOf(' ')+1, entity.teamName.length-1);
    this.getTeams(this.siteCASEman);
  }

  getTeams(select) {
    if(select.name == "all" && select.id == "0") {
      this.getCasemanTeams =  this.Caseman.getAllTeamsCASEMAN();
    } else {
      this.getCasemanTeams = this.Caseman.getTeamsCASEMANbySite(select.id);
    }

    this.getCasemanTeams.then(
      (success) => {
        this.teamsCASEMAN = success.data;
      },
      (error) => {
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  saveTeamMatch(team, teamToMatch) {
    this.state = "loading";
    this.Caseman.setTeams(team.teamId, angular.fromJson(teamToMatch).id).then(
      () => {
        this.selectedTeam = null;
        this.refresh();
      },
      (error) => {
        this.state = "error";
        this.matchBlocked = this.Utils.blockMatch(this.siteTeamsMapperDisplay);
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  deleteTeam(team) {
    this.state = "loading";
    this.Caseman.deleteTeamMapper(team.teamId).then(
      () => {
        this.selectedTeam = null;
        this.refresh();
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  cancel() {
    this.matchBlocked = this.Utils.blockMatch(this.siteTeamsMapperDisplay);
    this.selectedTeam = null;
  }
}